import { CURRENCY_SYMBOLS } from '../../utils/currency'

// Currency symbol shown before prices. "$" is the default.
interface CurrencySelectProps {
  value: string
  onChange: (symbol: string) => void
}

export const CurrencySelect = ({ value, onChange }: CurrencySelectProps) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    aria-label="Currency"
    className="px-3 py-2 text-sm font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-brand-primary bg-white text-gray-700"
  >
    {CURRENCY_SYMBOLS.map((symbol) => (
      <option key={symbol} value={symbol}>
        {symbol}
      </option>
    ))}
    <option value="">None</option>
  </select>
)
